import styled from "styled-components";

export const CustomButton = styled.button`
  width: ${(props) => props.width || "150px"};
  height: ${(props) => props.height || "40px"};
  background: ${(props) => props.background || "#6CAEFF"};
  border-radius: ${(props) => props.radius || "4px"};
  border-width: ${(props) => props.borderSize || "1px"};
  border-color: ${(props) => props.borderColor || "#6CAEFF"};
  border-style: ${(props) => props.style || "solid"};
  color: ${(props) => props.color || "#fff"};
  padding-right: 8px;
  padding-left: 8px;
  font-family: Peyda;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 500};
  font-size: ${(props) => props.fontSize || "16px"};
  line-height: 21px;
  margin-top:${(props)=> props.marginTop} ;
  text-align: center;
  word-wrap: break-word;
  cursor: pointer;
  transition: 0.7s;
  &:hover {
    background: ${(props) => props.backgroundHover || "#448ce4"};
    border-color: ${(props) => props.borderColorHover || "#448ce4"};
    color:${(props) => props.colorHover }
  }
  &:disabled {
    background: ${(props) => props.background || "#99b9e0"};
    border-color: ${(props) => props.borderColor || "#99b9e0"};
    cursor: auto;
  }
  
  /* @media (max-width:1240px) {
    width: ${props=> props.width1240 || "260px"}
  } */
  @media (max-width:850px){
    width: ${(props) => props.width850|| "220px"};
  }
 
  /* @media (max-width:680px){
    width: ${(props) => props.width680 || "180px"};
    font-size: ${(props) => props.fontSize680 || "14px"};
  } */
  @media (max-width:600px){
    width: ${(props) => props.width600 || "138px"};
  }
  @media (max-width:360px){
    width: ${(props) => props.width360 || "150px"};
  }

`;

export const ButtonIcon = styled.img`
  margin: 3px;
`;

export const WalletValue = styled.span`
  font-family: Iran-Yekan;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: ${props => props.color || "#27548c"};
  text-align: right;
  margin-right: 8px;
`;